<template>
  <el-dialog
    v-model="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="true"
    class="mobile-view-dialog"
  >
    <div class="mobile-view">
      <div class="mobile-view__content">
        <div class="mb-10">
          <img :src="unzerLogo" alt="Unzer Logo" class="h-8 w-auto" />
        </div>

        <div class="flex justify-start mb-2">
          <div
            class="w-12 h-12 bg-white flex items-center justify-center rounded-[3px]"
          >
            <desktop-mode-icon alt="Desktop" class="w-6 h-6" />
          </div>
        </div>

        <h1 class="text-2xl font-bold text-[#0c1332] mb-1 text-left">
          {{ $t('pages.mobile.title') }}
        </h1>

        <div class="mb-4">
          <p
            class="text-base text-[#0c1332] font-medium leading-relaxed mb-1 text-left"
          >
            {{ $t('pages.mobile.description1') }}
          </p>
          <p
            class="text-base text-[#0c1332] font-medium leading-relaxed mb-4 text-left"
          >
            {{ $t('pages.mobile.description2') }}
          </p>
        </div>

        <div class="flex gap-3">
          <el-button
            type="accent"
            class="font-semibold text-sm px-6 py-3"
            @click="handleLogout"
          >
            {{ $t('nav.main.items.logout.title') }}
          </el-button>
          <el-button
            class="font-semibold text-sm px-6 py-3"
            @click="handleContinue"
          >
            {{ $t('common.interactions.buttons.close') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { useAuthStore } from '@shared/store/auth'
import unzerLogo from '@shared/assets/images/unzer-logo-color.svg'
import { ref, onMounted, onUnmounted } from 'vue'
import { isUnifiedCommerce } from '@shared/constants'
import { DesktopModeIcon } from '@shared/assets/icons'

export default {
  name: 'MobileView',
  components: {
    DesktopModeIcon
  },
  emits: ['modal-dismissed'],
  setup(props, { emit }) {
    const authStore = useAuthStore()
    const visible = ref(false)
    const STORAGE_KEY = 'unzer_mobile_modal_dismissed'

    const checkScreenSize = () => {
      visible.value = window.innerWidth <= 640 && isUnifiedCommerce()
    }

    const handleLogout = () => {
      authStore.logout()
    }

    const handleContinue = () => {
      // Store the user's decision to dismiss the modal in localStorage
      localStorage.setItem(STORAGE_KEY, 'true')
      visible.value = false
      // Emit event to parent component
      emit('modal-dismissed')
    }

    onMounted(() => {
      checkScreenSize()
      window.addEventListener('resize', checkScreenSize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenSize)
    })

    return {
      handleLogout,
      handleContinue,
      unzerLogo,
      visible
    }
  }
}
</script>

<style scoped>
.mobile-view-dialog :deep(.el-dialog) {
  margin: 0;
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.mobile-view-dialog :deep(.el-dialog__body) {
  padding: 0;
  height: 100%;
  width: 100%;
}

.mobile-view-dialog :deep(.el-overlay) {
  padding: 0;
}

.mobile-view {
  width: 100vw;
  height: 100vh;
  background-color: #f1f1f3;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-view__content {
  padding: 1.5rem;
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
}
</style>
